<mat-form-field>
  <mat-label>{{ control.label}}</mat-label>
  <textarea matInput [formControl]="inputControl" [ngClass]="{ 'no-resize': resizeDisabled}" [readonly]="isReadonly" [attr.maxLength]="maxLength" cols="120"></textarea>
  @if (maxLength) {
    <mat-hint align="end">{{inputControl.value?.length || 0}} / {{maxLength}}</mat-hint>
  }
</mat-form-field>
